import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (this.element.closest("turbo-frame")) this.element.closest("turbo-frame").reload()
    this.element.remove()
  }
}
